<div class="white-bg no-padding no-margin">
  <!-- <breadcrumbs>
      <breadcrumb route="/" label="Dashboard"></breadcrumb>
      <breadcrumb [currentRoute]="true" label="Setup Training Types and Section"></breadcrumb>
    </breadcrumbs> -->


  <mat-card>
    <div style="text-align: center;">
      <span class="title-header">{{"Component Criticality" | translate | async}}</span>
    </div>

    <div style="    padding: 2%;">

      <span style="font-size: larger; "><b>{{"Select Family" | translate | async}}</b></span>

      <!-- <input value="ROPE SHOVEL" style="width: 345px;     margin-left: 2%;margin-right: 6%;" disabled> -->
      

      <mat-select [(ngModel)]="selectedfamilyId" name="family" style="width: 345px;margin-left: 2%;"  [placeholder]="'Select Family' | translate | async" (selectionChange)="LoadMakeList()">
        <mat-option value="203">Rope Shovel</mat-option>
        <mat-option value="177">Hydraulic Shovel/Excavator</mat-option>
      </mat-select>

      <span style="font-size: larger; "><b>{{"Select Make" | translate | async}}</b></span>
      <mat-select [placeholder]="'Select Make' | translate | async" style="width: 345px;     margin-left: 2%;margin-right: 6%;"
        [(ngModel)]="selectedMakeId">
        <mat-option *ngFor="let make of makeList" [value]="make.Id" (click)="makeSelected()">
          {{make.Name}}
        </mat-option>
      </mat-select>

      <ng-container>
        <span style="font-size: larger; "><b>{{"Select Model" | translate | async}}</b></span>
        <mat-select [placeholder]="'Select Model' | translate | async" style="width: 345px;     margin-left: 2%;" [(ngModel)]="selectedModelId">
          <mat-option *ngFor="let model of modelList" [value]="model.Id" (click)="modelSelected()">
            {{model.Name}}
          </mat-option>
        </mat-select>
      </ng-container>


    </div>


    <div class="panel panel--components" [@fadeInOut]>
      <div class="panel__header">
        <span class="panel__header__title">
          {{"Component List" | translate | async}}
        </span>
      </div>
      <div style="display: flex; flex-direction: row;     background-color: #F5F8FB;">


        <div class="panel__content no-padding">
          <table class="table table--striped table--half-width">
            <thead>
              <tr>
                <th>{{'Component Type' | translate | async}}</th>
                <th>{{'Component' | translate | async}}</th>
                <th></th>
                <th>{{'% Contribution to UC Eval' | translate | async}}</th>
                <th></th>
                <!-- <th>{{'Models' | translate | async}}</th>
                <th>{{'Make' | translate | async}}</th> -->
              </tr>
            </thead>
            <tbody>
              <tr class="table-row-style" *ngFor="let component of components">



                <td>{{component.CompartType}} </td>
                <td>{{component.CompartName}}</td>
                <td *ngIf="component.CompartType=='TrackRoller'"> <span>
                    <input class="inputData" type="number" title="" [(ngModel)]="component.ContributionPercentage"
                      (change)="AddCompartContributionPercentage($event,component)"> x 8
                  </span>
                </td>

                <td *ngIf="component.CompartType=='CrawlerFrameGuide'"> <span>
                  <input class="inputData" type="number" title="" [(ngModel)]="component.ContributionPercentage"
                    (change)="AddCompartContributionPercentage($event,component)"> x 2
                </span>
              </td>

                <td *ngIf="component.CompartType!='TrackRoller' && component.CompartType!='CrawlerFrameGuide'"></td>


                <td *ngIf="component.CompartType!='TrackRoller' && component.CompartType!='CrawlerFrameGuide'">
                  <span>
                    <input class="inputData" type="number" title="" [(ngModel)]="component.ContributionPercentage"
                      (change)="AddCompartContributionPercentage($event,component)"> %
                  </span>
                </td>


                <td *ngIf="component.CompartType=='TrackRoller' || component.CompartType=='CrawlerFrameGuide'">
                  <span>
                    <input class="inputData" type="number" title="" [(ngModel)]="component.calculatedPercent"
                      disabled > %
                  </span>
                </td>
                <td>
                  <a> <i class="material-icons square-button__icon" (click)="loadMeasurementPoints(component.CompartId)"
                      style="cursor: pointer;">add</i> </a>
                </td>

              </tr>
              <tr>
                <td></td>
                <td></td>
                <td> <span style="font-size: 16px;font-weight: bold;
                  margin-right: 30px;">{{"Total" | translate | async}}</span></td>
                <td>
                  <span [ngClass]="getColourCompartTotal()">
                    <div style="font-size: 16px;font-weight: bold;"> {{totalCompContribution.toFixed(1)}} % </div>
                  </span>
                  <!-- <span style="font-size: 16px;font-weight: bold;">{{totalCompContribution.toFixed(1)}} %</span></td> -->
                <td></td>
              </tr>
            </tbody>


          </table>

        </div>

        <div class="panel__content no-padding" *ngIf="IsMeasurementShow==true" style="margin-left: 10%;">
          <div class="panel__header">
            <span class="panel__header__title">
              {{"Measurement Point List For" | translate | async}} {{componentTypePlusName}}
            </span>
          </div>

          <table class="table table--striped table--half-width">
            <thead>
              <tr>
                <th>{{'Measurement Point Description' | translate | async}}</th>
                <th>{{'% Contribution to Compart' | translate | async}}</th>

                <!-- <th>{{'Models' | translate | async}}</th>
                <th>{{'Make' | translate | async}}</th> -->
              </tr>
            </thead>
            <tbody>
              <tr class="table-row-style" *ngFor="let measurement of measurementPoints">

                <td>{{measurement.Name}}</td>
                <td>
                  <span>
                    <input class="inputData" type="number" title="" [(ngModel)]="measurement.ContributionPercentage"
                      (change)="AddMeasurementContributionPercentage($event,measurement)">
                    %
                  </span>
                </td>
              </tr>
              <tr>
                <td> <span style="font-size: 16px;font-weight: bold;
                  margin-right: 30px;">{{"Total" | translate | async}}</span></td>
                <td>

                  <span [ngClass]="getColourMPTotal()">
                    <div style="font-size: 16px;font-weight: bold;"> {{totalMPContribution.toFixed(1)}} % </div>
                  </span>
                  <!-- <span style="font-size: 16px;font-weight: bold;">{{totalMPContribution.toFixed(1)}} %</span> -->
                </td>
              </tr>
            </tbody>


          </table>


        </div>

      </div>

    </div>
  </mat-card>
</div>